enum TipoFiltroBuscaEleitoresDiscenteEnum {
  CURSO,
  DEPARTAMENTO,
  CENTRO,
  PERSONALIZADO,
}

export default TipoFiltroBuscaEleitoresDiscenteEnum;
